<ng-container *ngIf="active && !done">
  <div *ngIf="celebrate" class="fw-dim" [style.animation-duration.ms]="duration"></div>
  <canvas #canvas class="fw-canvas" aria-hidden="true"></canvas>
  <div *ngIf="greeting" class="fw-greeting" role="status" [style.animation-duration.ms]="duration">
    <app-festive-doodle size="lg"></app-festive-doodle>
    <strong class="fw-greeting__title">{{ greeting }}</strong>
    <span *ngIf="subtitle" class="fw-greeting__text">{{ subtitle }}</span>
  </div>
</ng-container>
